export default __webpack_public_path__ + "static/media/WormViz_2.30d677ea.png";